import React, { useEffect, useState } from "react";
import { Wifi, CircleAlert } from "lucide-react";

interface PoorConnectionWarningProps {
  show: boolean;
  onDismiss?: () => void;
}

export const PoorConnectionWarning: React.FC<PoorConnectionWarningProps> = ({
  show,
  onDismiss,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (show) {
      setIsVisible(true);
      // Auto-dismiss after 5 seconds
      const timer = setTimeout(() => {
        setIsVisible(false);
        onDismiss?.();
      }, 5000);

      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [show, onDismiss]);

  if (!show || !isVisible) return null;

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-[9998]">
      <div className="bg-orange-600/95 backdrop-blur-sm rounded-2xl border border-orange-500/50 px-6 py-4 shadow-xl max-w-md">
        <div className="flex items-center gap-3">
          {/* Warning Icon */}
          <div className="w-8 h-8 relative flex justify-center items-center">
            <div className="w-8 h-8 absolute bg-orange-500/30 rounded-full" />
            <Wifi
              className="w-5 h-5 text-orange-100 z-10"
              strokeWidth={2}
              aria-label="Poor connection icon"
            />
          </div>

          {/* Message Content */}
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <CircleAlert className="w-4 h-4 text-orange-100" strokeWidth={2} />
              <span className="text-orange-100 text-sm font-semibold font-satoshi">
                Poor Connection Quality
              </span>
            </div>
            <p className="text-orange-100/80 text-xs font-normal font-satoshi">
              Network quality is degraded. Call may be affected.
            </p>
          </div>

          {/* Dismiss Button */}
          <button
            onClick={() => {
              setIsVisible(false);
              onDismiss?.();
            }}
            className="text-orange-100/60 hover:text-orange-100 transition-colors text-xl leading-none"
            aria-label="Dismiss warning"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
};